// import TextToSpeech from "./TextToSpeech";
import TextToSpeech from "./TextToSpeech2";
import React, { useRef } from "react";


function TextPost({ item }) {

  console.log("INI PROPS AUDIO", item)

  return (
    <div style={{ display: item.ANTRIAN_DOKTER == "" ? 'none' : null }} >
      <TextToSpeech text={item} />
      {/* <TextToSpeech text={"panggilan untuk nomor antrian " + item.KATEGORI_KONSULTASI + " " + item.ANTRIAN_DOKTER.split('').join('  ') + " ,harap masuk ke ruangan " + item.KATEGORI_KONSULTASI +", terima kasih"} /> */}
      {/* <TextToSpeech text={"panggilan untuk nomor antrian " + item.NAMA_KONSULTASI + " " + item.ANTRIAN_DOKTER.split('').join(',') + " ,harap masuk ke ruangan " + item.NAMA_KONSULTASI +", terima kasih"} /> */}
    </div>
  );
}

export default TextPost;
